<div class="container" (click)="onBannerClick()" [style.cursor]="redirectUrl ? 'pointer' : 'default'">
  <div>
    <img class = "imageMargin"
      src="../../../../assets/img/icono-banner.png"
      alt="Ícono Banner"
      style="fill: #FFFFFF; width: 90%;"
    />
  </div>
  <div>
    <p class="title">{{ title }}</p>
    <br />
    <p class="subtitle">{{ subtitle }}</p>
  </div>
</div>
